export function scrollIntoViewWithOffset(selector, offset) {
    const element = document.querySelector(selector);
    if (!element) {
        return;
    }

    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth',
    });
}

export function getHash() {
    const hash = window.location.href.split('#').pop();
    if (hash && hash !== window.location.href) {
        return hash;
    }
    return '';
}
